import { Divider, List } from '@mui/material';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import vbeeGrayIcon from '@src/assets/icons/vbee-icon-gray.svg';
import vbeeWhiteIcon from '@src/assets/icons/vbee-icon-white.svg';
import Feature from '@src/components/Feature';
import FEATURE_FLAG from '@src/constants/featureFlags.json';
import { SMS_IDENTITY_PROVIDER } from '@src/constants';
import ROUTES from '@src/constants/route';
import logoAiVoice from '@src/assets/logo/logo-AiVoice-new.svg';
import SidebarImgIcon from '../../Icon';
import { StyledSidebarNew } from './index.style';

import UserInfo from '../UserInfo';
import VoucherAds from '../VoucherAds';

const LargeSidebar = ({
  createLinks,
  sidebarRoute,
  activeRoute,
  ipLocation,
  handleCloseSidebar,
  // renderSubMenuSupport,
  isExpiredPackage,
  vouchers,
  showAutoRenewalBanner,
  useHeaderBanner,
  headerVoucher,
  identityProvider,
}) => {
  const sidebarBodyRef = useRef(null);
  const [showScrollbar, setShowScrollbar] = useState(false);

  const { t } = useTranslation();

  const notShowVoucherAds = Object.values(SMS_IDENTITY_PROVIDER).includes(
    identityProvider,
  );

  const renderSideBarItems = (props) => (
    <div
      ref={sidebarBodyRef}
      onMouseEnter={() => setShowScrollbar(true)}
      onMouseLeave={() => setShowScrollbar(false)}
      className={`sidebar-wrapper ${
        showScrollbar ? 'small-scrollbar' : 'hidden-scrollbar'
      } `}
    >
      <List className="list" style={{ paddingBottom: '0px' }}>
        {createLinks(sidebarRoute, props)}
      </List>
      <Feature name={FEATURE_FLAG.OTHER_SERVICES}>
        <NavLink
          to={ROUTES.OTHER_SERVICES}
          className={classNames('item-link', {
            'active-link': activeRoute(ROUTES.OTHER_SERVICES),
          })}
          onClick={() => {
            if (props?.mobile) handleCloseSidebar();
          }}
        >
          <SidebarImgIcon
            src={
              activeRoute(ROUTES.OTHER_SERVICES) ? vbeeWhiteIcon : vbeeGrayIcon
            }
            name={t('otherServices')}
          />
        </NavLink>
      </Feature>
    </div>
  );

  return (
    <StyledSidebarNew
      useHeaderBanner={useHeaderBanner}
      headerVoucher={headerVoucher}
    >
      <div className="brand">
        <img
          src={logoAiVoice}
          alt="vbee tts logo"
          className="logo-img"
          width={108}
        />
      </div>
      <Divider />
      {renderSideBarItems()}
      {!notShowVoucherAds && (
        <VoucherAds
          isExpiredPackage={isExpiredPackage}
          showAutoRenewalBanner={showAutoRenewalBanner}
          vouchers={vouchers}
        />
      )}

      <Divider sx={{ marginTop: '12px' }} />
      <UserInfo
        handleCloseSidebar={handleCloseSidebar}
        ipLocation={ipLocation}
      />
    </StyledSidebarNew>
  );
};

export default LargeSidebar;
